import { render, staticRenderFns } from "./AudienceDetail.vue?vue&type=template&id=51a6828d&"
import script from "./AudienceDetail.vue?vue&type=script&lang=ts&"
export * from "./AudienceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports